import React from 'react'
import SVG from 'react-inlinesvg'

type InlineSVGProps = {
  src: string
  className?: string
}

const InlineSVG = SVG as unknown as React.ComponentType<InlineSVGProps>

export {InlineSVG}
